/* eslint-disable no-nested-ternary */
// Added for lazy load of devtools extension
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import { createStore, applyMiddleware, combineReducers, AnyAction, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import getConfig from 'next/config';
import { HYDRATE, createWrapper, MakeStore, Context } from 'next-redux-wrapper';
import authenticationReducers from 'src/authentication/reducers/authenticationReducers';
import dynamicMiddlewares from 'redux-dynamic-middlewares';
import paymentReducers from 'src/payments/reducers';
import grammarReducers from 'src/grammar-checker/reducers';
import paraphraserReducer from 'src/paraphraser/reducers/paraphraserReducer';
import summarizerReducers from 'src/summarizer/reducers';
import citationGeneratorReducers from 'src/citation-generator/reducers';
import plagiarismCheckerReducers from 'src/plagiarism-checker/reducers';
import { CHAR_LIMITS } from 'config/constants';
import commonReducers from '../reducers/commonReducers';
import { RootState } from '../models/redux/store';

const { publicRuntimeConfig } = getConfig();
let storeInstance: Store;
/**
 * Combining all reducers into a single reducers.
 */
const combinedReducer = combineReducers({
  user: authenticationReducers,
  common: commonReducers,
  smzr: summarizerReducers,
  grmr: grammarReducers,
  pymt: paymentReducers,
  pphr: paraphraserReducer,
  ctgr: citationGeneratorReducers,
  plac: plagiarismCheckerReducers,
});

/**
 * dynamicMiddlewares is used to dynamically add module specific middlewares.
 * Check for addMiddleware in code to see how to add dynamic middleware.
 */
const bindMiddleware = () => {
  let middlewares;
  if (process.browser) {
    middlewares = applyMiddleware(thunkMiddleware, dynamicMiddlewares);
  } else {
    middlewares = applyMiddleware(thunkMiddleware);
  }

  if (
    !['dev', 'qa', 'test', 'stage', 'prod', 'production'].includes(publicRuntimeConfig.QUILLBOT_ENV)
  ) {
    const { composeWithDevTools } = require('redux-devtools-extension');
    return composeWithDevTools(middlewares);
  }
  return middlewares;
};

// https://github.com/piotrwitek/typesafe-actions/issues/26 types for the reducers are currently missing
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reducer = (state: any, action: AnyAction | any) => {
  switch (action.type) {
    case HYDRATE:
      // if (!process.browser) {
      // NOTE: only override the values here which are set by server or which app expects from server
      // Please beware before changing below code
      return {
        ...state,
        user: { ...state?.user, ...action.payload?.user },
        common: {
          ...state?.common,
          ...action.payload?.common,
          platform: {
            ...state.common?.platform,
            ...action.payload?.common?.platform,
          },
          maintenance: {
            ...state.common?.maintenance,
          },
        },
        pphr: {
          ...state?.pphr,
          ...action?.payload?.pphr?.userOnboardingStatus,
          inputWordLimit: action.payload?.user?.isAuthenticated
            ? action.payload?.user?.premium
              ? CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_PREMIUM
              : CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_MEMBER
            : CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_GUEST,
          ...action?.payload?.pphr?.isDialogOpen,
        },
        grmr: {
          ...state?.grmr,
          ...action.payload?.grmr,
        },
        // ...action.payload,
      };
    // }
    // return state;
    default:
      return combinedReducer(state, action);
  }
};

const makeStore: MakeStore<Store<RootState>> = (context: Context) => {
  storeInstance = createStore(reducer, bindMiddleware());
  return storeInstance;
};

/**
 * Method to get store instance at client side.
 */
export const getReduxStore = () => {
  if (process.browser) {
    // eslint-disable-next-line no-underscore-dangle
    return storeInstance;
  }
  return null;
};

export const wrapper = createWrapper<Store<RootState>>(makeStore);
